/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import {Box, useMultiStyleConfig, Flex} from '@salesforce/retail-react-app/app/components/shared/ui'
import {BrandLogo} from '../../../components/icons'
import LegalLinks from '../../../components/footer/legal-links'
import {useGetFooterByContentType} from '../../../custom-api/hooks/use-get-footer'

const CheckoutFooter = ({...otherProps}) => {
    const styles = useMultiStyleConfig('Footer', {variant: 'checkout'})

    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
    const {data, isFetching, isLoading, isError} = useGetFooterByContentType()
    const footerGroup = data?.footer_content?.footer_reference_components || []

    const getComponentData = (contentType) => {
        return footerGroup.find((item) => item?._content_type_uid === contentType)
    }

    const footerBottom = getComponentData('footerbottom')
    const footerData = footerBottom?.footer_bottom_group
    const copyrightGroup = footerData?.copyright_group

    return (
        <Box {...styles.outerContainer}>
            <Box as="footer" {...styles.container} sx={styles.containerSpacing} {...otherProps}>
                <Flex {...styles.cartBrandLegal}>
                    <BrandLogo
                        data-testid="brand-logo"
                        inverted={true}
                        {...styles.footerBrand}
                        {...styles.cartFooterBrand}
                    />
                    <LegalLinks
                        variant="horizontal"
                        data-testid="legal-links"
                        links={copyrightGroup?.copyright_links}
                    />
                </Flex>
            </Box>
        </Box>
    )
}

export default CheckoutFooter
